import VideoEmbed from '../video-embed';

<template>
  <div class='widget-item'>
    <div class='section-title-wrap violet'>
      <h2 class='section-title medium'>Live Tournament</h2>
      <div class='section-title-separator'></div>
    </div>
    <VideoEmbed @src={{@match.liveVideoUrl}} @size='large' @title='Live tournament stream' />
  </div>
</template>
